import {DodgerBlueColor} from '../../cmsMainStyle'

const tabMenu = theme => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},

	secordRoot: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
		paddingTop: 10,
		paddingBottom: 10,
	},
	
	userRightMsg: {
		padding: theme.spacing(3),
		color: "red",
	},


	MenuBar: {

		width: "100%",
		marginTop: "4px",
		marginRight: "10px",
		textAlign: 'right',
	},

	toolMenuBtn: {
		background: DodgerBlueColor[11],
		'&:hover': {
			background: DodgerBlueColor[13],
		},
	},

})


export default tabMenu